var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconKakao02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAE300",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#391B1B",
  d: "M20.066 12.094c-4.695 0-8.5 3.008-8.5 6.72a6.57 6.57 0 0 0 4.032 5.717c-.177.664-.644 2.405-.737 2.775-.115.463.17.456.356.332.145-.1 2.33-1.586 3.27-2.222q.785.117 1.577.116c4.695 0 8.501-3.01 8.501-6.72s-3.806-6.72-8.5-6.72"
})));
export default SvgIconKakao02;